import { FC } from 'react';
import { useTranslation, Trans } from 'next-i18next';
import {
  BOATING_EDUCATION_LINKS,
  EXTERNAL_PATHS,
  PATHS,
} from 'src/common/constants';
import Typography from 'src/common/components/Typography';
import UniversalLink from 'src/common/components/UniversalLink';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import LocationFAQs from 'src/search/components/dockyard/LocationFAQs';
import styles from './FAQs.module.scss';

const FAQs: FC = () => {
  const [t] = useTranslation('parties-page');
  const list = Array.from(Array(7).keys());
  const faqs = [
    {
      question: t('faq--question-0'),
      answer: (
        <Typography type="p" size="body-l">
          <Trans
            t={t}
            i18nKey="faq--answer-0--p-0"
            components={{
              break: <br />,
            }}
          />
        </Typography>
      ),
    },
    {
      question: t('faq--question-1'),
      answer: (
        <Typography type="p" size="body-l">
          {t('faq--answer-1--p-0')}
        </Typography>
      ),
    },
    {
      question: t('faq--question-2'),
      answer: (
        <Typography type="p" size="body-l">
          <Trans
            t={t}
            i18nKey="faq--answer-2--p-0"
            components={{
              boatEdLink: (
                <UniversalLink
                  href={BOATING_EDUCATION_LINKS.BOAT_ED}
                  openInNewTab
                />
              ),
            }}
          />
        </Typography>
      ),
    },
    {
      question: t('faq--question-3'),
      answer: (
        <Typography type="p" size="body-l">
          <Trans
            t={t}
            i18nKey="faq--answer-3--p-0"
            components={{
              homeLink: (
                <UniversalLink
                  href={PATHS.HOME}
                  openInNewTab
                />
              ),
            }}
          />
        </Typography>
      ),
    },
    {
      question: t('faq--question-4'),
      answer: (
        <>
          <Typography type="p" size="body-l">
            {t('faq--answer-4--p-0')}
          </Typography>
          <ul>
            {list.map((key: number) => (
              <li key={key}>
                <Typography type="p" size="body-l">
                  <Trans
                    t={t}
                    i18nKey={`faq--answer-4--li-${key}`}
                    components={{

                    }}
                  />
                </Typography>
              </li>
            ))}
          </ul>
          <Typography type="p" size="body-l">
            <Trans
              t={t}
              i18nKey="faq--answer-4--p-1"
              components={{
                journalLink: (
                  <UniversalLink
                    href={EXTERNAL_PATHS.JOURNAL}
                    openInNewTab
                  />
                ),
              }}
            />
          </Typography>
        </>
      ),
    },
    {
      question: t('faq--question-5'),
      answer: (
        <Typography type="p" size="body-l">
          {t('faq--answer-5--p-0')}
        </Typography>
      ),
    },
    {
      question: t('faq--question-6'),
      answer: (
        <>
          <Typography type="p" size="body-l">
            {t('faq--answer-6--p-0')}
          </Typography>
          <ul>
            {list.map((key: number) => (
              <li key={key}>
                <Typography type="p" size="body-l">
                  <Trans
                    t={t}
                    i18nKey={`faq--answer-6--li-${key}`}
                    components={{
                      weatherLink: (
                        <UniversalLink
                          href={`${EXTERNAL_PATHS.JOURNAL}how-to/gear-for-boating-in-foul-weather/`}
                          openInNewTab
                        />
                      ),
                      sunscreenLink: (
                        <UniversalLink
                          href={`${EXTERNAL_PATHS.JOURNAL}how-to-take-care-of-your-skin-while-boating/`}
                          openInNewTab
                        />
                      ),
                    }}
                  />
                </Typography>
              </li>
            ))}
          </ul>
          <Typography type="p" size="body-l">
            <Trans
              t={t}
              i18nKey="faq--answer-6--p-1"
              components={{
                journalLink: (
                  <UniversalLink
                    href={EXTERNAL_PATHS.JOURNAL}
                    openInNewTab
                  />
                ),
              }}
            />
          </Typography>
        </>
      ),
    },
  ];

  return (
    <PitchPageLayout backgroundColor="pearl">
      <div className={styles.root}>
        <Typography
          type="h2"
          size="display-5"
        >
          {t('faq--title')}
        </Typography>
        <div className={styles.faqWrapper}>
          {faqs.map((faq) => (
            <LocationFAQs key={faq.question} title={faq.question}>
              <div>
                {faq.answer}
              </div>
            </LocationFAQs>
          ))}
        </div>
      </div>
    </PitchPageLayout>
  );
};

export default FAQs;
